export const setRedirectURL = redirectURL => {
	return { type: 'SET_REDIRECT_URL', redirectURL };
};